<nav class="navbar navbar-expand-sm navbar-dark bg-dark p-1">
  <div class="container">
    <a class="navbar-brand" (click)="onDashboardClick()">Ecademictube</a>
    <button class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav">
        <li class="nav-item px-2">
          <a class="nav-link" (click)="onSessionsClick()">Sessions</a>
        </li>
        <li class="nav-item px-2">
          <a class="nav-link" (click)="onStudentsClick()">Students</a>
        </li>
        <li class="nav-item px-2">
          <a class="nav-link" (click)="onTutorsClick()">Tutors</a>
        </li>
        <li class="nav-item px-2">
          <a class="nav-link" (click)="onSubAdminsClick()">Sub-admins</a>
        </li>
      </ul>

      <ul class="navbar-nav ml-auto">
        <li class="nav-item mr-3">
          <a class="nav-link">
            <i class="fas fa-user"></i> Welcome Admin
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="onLogout()" style="cursor: pointer;">
            <i class="fas fa-user-times"></i> Logout
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<app-ecadashboard *ngIf="dashboard"></app-ecadashboard>
<app-ecasessions *ngIf="sessions"></app-ecasessions>
<app-ecastudents *ngIf="students"></app-ecastudents>
<app-ecatutors *ngIf="tutors"></app-ecatutors>
<app-ecasub-admins *ngIf="subAdmins"></app-ecasub-admins>
